import bem from 'utils/bem';

export const block = bem('audio-wave-options');
